import React from 'react';
import { Link } from 'react-router-dom';
import { Cookie, ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';

const openPreferences = () => {
  window.dispatchEvent(new CustomEvent('open-cookie-preferences'));
};

export default function PolitiqueCookies() {
  return (
    <div className="min-h-screen bg-[#1a1c1b] text-[#dfddd6]" data-testid="page-politique-cookies">
      <Header />
      <main className="max-w-4xl mx-auto px-5 md:px-10 py-20 md:py-28">
        <Link to="/" className="inline-flex items-center gap-2 text-[#888680] hover:text-[#d9fb06] transition-colors mb-8 text-sm">
          <ArrowLeft size={16} /> Retour à l'accueil
        </Link>

        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-[#d9fb06]/10 rounded-full flex items-center justify-center">
            <Cookie className="text-[#d9fb06]" size={24} />
          </div>
          <h1 className="font-black text-4xl md:text-5xl text-[#d9fb06] uppercase">Politique cookies</h1>
        </div>
        <p className="text-[#888680] mb-10 text-sm">Dernière mise à jour : 21 juillet 2026</p>

        <div className="prose prose-invert max-w-none">
          <h2 className="text-2xl font-bold text-[#d9fb06] mt-8 mb-4">1. Qu'est-ce qu'un cookie ?</h2>
          <p className="text-[#dfddd6] leading-relaxed">
            Un cookie est un petit fichier texte déposé sur votre appareil lorsque vous visitez notre site.
            Il permet au site de mémoriser vos préférences ou de collecter des informations sur votre utilisation.
          </p>

          <h2 className="text-2xl font-bold text-[#d9fb06] mt-8 mb-4">2. Cookies utilisés sur ce site</h2>

          <div className="overflow-x-auto mt-4">
            <table className="w-full border-collapse text-sm">
              <thead>
                <tr className="bg-[#302f2c] border border-[#3f4816]">
                  <th className="p-3 text-left text-[#d9fb06] border border-[#3f4816]">Nom</th>
                  <th className="p-3 text-left text-[#d9fb06] border border-[#3f4816]">Fournisseur</th>
                  <th className="p-3 text-left text-[#d9fb06] border border-[#3f4816]">Finalité</th>
                  <th className="p-3 text-left text-[#d9fb06] border border-[#3f4816]">Durée</th>
                  <th className="p-3 text-left text-[#d9fb06] border border-[#3f4816]">Catégorie</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border border-[#3f4816]">
                  <td className="p-3 border border-[#3f4816] font-mono text-xs">validated_consent</td>
                  <td className="p-3 border border-[#3f4816]">ValidatedBoat</td>
                  <td className="p-3 border border-[#3f4816]">Stockage de vos choix de consentement</td>
                  <td className="p-3 border border-[#3f4816]">6 mois</td>
                  <td className="p-3 border border-[#3f4816]"><span className="text-[#d9fb06]">Essentiel</span></td>
                </tr>
                <tr className="border border-[#3f4816]">
                  <td className="p-3 border border-[#3f4816] font-mono text-xs">admin_token</td>
                  <td className="p-3 border border-[#3f4816]">ValidatedBoat</td>
                  <td className="p-3 border border-[#3f4816]">Session administrateur (backoffice uniquement)</td>
                  <td className="p-3 border border-[#3f4816]">Session</td>
                  <td className="p-3 border border-[#3f4816]"><span className="text-[#d9fb06]">Essentiel</span></td>
                </tr>
                <tr className="border border-[#3f4816]">
                  <td className="p-3 border border-[#3f4816] font-mono text-xs">sellBoatPopupClosed</td>
                  <td className="p-3 border border-[#3f4816]">ValidatedBoat</td>
                  <td className="p-3 border border-[#3f4816]">Mémorise la fermeture de la popup d'estimation</td>
                  <td className="p-3 border border-[#3f4816]">Session</td>
                  <td className="p-3 border border-[#3f4816]"><span className="text-[#d9fb06]">Essentiel</span></td>
                </tr>
                <tr className="border border-[#3f4816]">
                  <td className="p-3 border border-[#3f4816] font-mono text-xs">ph_*</td>
                  <td className="p-3 border border-[#3f4816]">PostHog (US)</td>
                  <td className="p-3 border border-[#3f4816]">Mesure d'audience anonymisée, aide à améliorer le site</td>
                  <td className="p-3 border border-[#3f4816]">12 mois</td>
                  <td className="p-3 border border-[#3f4816]"><span className="text-yellow-400">Analytique</span></td>
                </tr>
                <tr className="border border-[#3f4816]">
                  <td className="p-3 border border-[#3f4816] font-mono text-xs">stripe / __stripe_*</td>
                  <td className="p-3 border border-[#3f4816]">Stripe (US/EU)</td>
                  <td className="p-3 border border-[#3f4816]">Sécurité anti-fraude sur les pages de paiement</td>
                  <td className="p-3 border border-[#3f4816]">1 an</td>
                  <td className="p-3 border border-[#3f4816]"><span className="text-[#d9fb06]">Essentiel</span></td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 className="text-2xl font-bold text-[#d9fb06] mt-8 mb-4">3. Vos choix</h2>
          <p className="text-[#dfddd6] leading-relaxed">
            À votre première visite, un bandeau vous permet d'accepter, refuser ou personnaliser vos cookies.
            Vous pouvez modifier ce choix à tout moment en cliquant sur le bouton ci-dessous ou sur le lien "Gérer mes cookies" en bas de page.
          </p>
          <Button
            onClick={openPreferences}
            data-testid="policy-open-preferences-btn"
            className="mt-4 bg-[#d9fb06] text-[#1a1c1b] hover:bg-[#d9fb06]/90 rounded-full px-6 py-3 font-bold uppercase text-sm"
          >
            <Cookie size={16} className="mr-2" />
            Gérer mes cookies
          </Button>

          <h2 className="text-2xl font-bold text-[#d9fb06] mt-8 mb-4">4. Réglages du navigateur</h2>
          <p className="text-[#dfddd6] leading-relaxed">
            Vous pouvez également configurer votre navigateur pour bloquer tous les cookies ou vous alerter à chaque dépôt.
            Attention : certains services (comme la connexion admin) pourraient ne plus fonctionner.
          </p>

          <h2 className="text-2xl font-bold text-[#d9fb06] mt-8 mb-4">5. Contact</h2>
          <p className="text-[#dfddd6] leading-relaxed">
            Pour toute question concernant nos cookies : <Link to="/politique-confidentialite" className="text-[#d9fb06] underline">contactez-nous</Link>.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
